import React, { useState } from 'react';
import { Button, Form, Header, Image, InputOnChangeData, Segment } from 'semantic-ui-react';
import trialytix from '../../../assets/svg/trialytix.svg';
import { ICredentials } from '../../../types/auth';

interface Props {
  login: (credentials: ICredentials) => void;
  resetPassword: (route: string) => void;
}

const LoginComponent = (props: Props): JSX.Element => {
  const [credentials, setCredentials] = useState<ICredentials>({
    email: '',
    password: '',
    totp: '',
    remember_me: false,
  })

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
    const trimmed_value = data.value.trim()
    event.target.value = trimmed_value
    setCredentials(prev => ({ ...prev, email: trimmed_value}))
  }

  const handleChangePassword = (data: InputOnChangeData) => {
    setCredentials(prev => ({ ...prev, password: data.value }))
  }

  const handleLogin = () => {
    props.login(credentials)
  }

  const handleRememberMeClick = () => {
    setCredentials(prev => ({ ...prev, remember_me: !credentials.remember_me }))
  }

  const handleResetPass = () => {
    props.resetPassword('/reset-password')
  }

  const renederRememberMeBtn = () => {
    if (credentials.remember_me) {
      return (
        <Button style={{ height: '1.25rem', width: '1.25rem', borderRadius: '0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }} primary={true} icon='check' onClick={handleRememberMeClick} />
      )
    }

    return (
      <div style={{ cursor: 'pointer', marginRight: '0.3rem', background: '#E0E1E2', height: '1.55rem', width: '1.55rem', borderRadius: '0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={handleRememberMeClick} />
    )
  }

  return (
    <Segment style={{ border: 'none', background: 'white', height: '45rem', width: '39.3rem', borderRadius: '8px', boxShadow: '0 0 25px -5px rgba(21,21,21,0.1)' }}>
      <Header textAlign='center' style={{ padding: '3rem', fontSize: '2.5rem' }}>
        <Image style={{ marginBottom: '1.07rem' }} src={trialytix} /><br />
        Sign in to Trialytix
      </Header>
      <Form size='large' style={{ textAlign: 'left', padding: '0 3rem 3rem 3rem' }}>
        <label style={{ fontWeight: 500, textAlign: 'left', color: '#747678', fontSize: '1.125rem', paddingBottom: '1rem' }}>E-Mail</label>
        <Form.Input
          labelPosition='left'
          style={{ borderRadius: '8px', marginTop: '1rem' }}
          fluid={true}
          size='large'
          placeholder='Enter E-Mail address'
          onChange={(e, data) => { handleChangeEmail(e, data) }}
        />
        <label style={{ fontWeight: 500, textAlign: 'left', color: '#747678', fontSize: '1.125rem', paddingBottom: '1rem' }}>Password</label>
        <Form.Input
          size='large'
          style={{ borderRadius: '8px', marginTop: '1rem' }}
          fluid={true}
          placeholder='Password'
          type='password'
          onChange={(e, data) => { handleChangePassword(data) }}
        />
        <Form.Group style={{ justifyContent: 'space-between', margin: 0, marginLeft: '0' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {renederRememberMeBtn()}
            <div style={{ textAlign: 'left', color: '#747678', fontSize: '1.125rem' }}>Remember me</div>
          </div>
          <a style={{ cursor: 'pointer', textAlign: 'left', color: '#747678', fontSize: '1.125rem' }} onClick={handleResetPass}>Forgot password?</a>
        </Form.Group>
        <Button
          primary
          fluid
          onClick={() => handleLogin()}
          content='Login'
          style={{ marginTop: '2rem', height: '50px', borderRadius: '8px', padding: 0, fontSize: '18px', lineHeight: '21px', letterSpacing: '0.25px' }}
        />
      </Form>
    </Segment>
  )
}

export default LoginComponent
